(function () {
  "use strict";

  HomeListCtrl.$inject = ['$scope', 'gridFormatters', 'trackingService'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HomeListCtrl', HomeListCtrl);

  function HomeListCtrl($scope, gridFormatters, trackingService) {

    var columns = [
      {
        id: "name",
        name: "Name",
        field: "name",
        width: 300,
        cssClass: "cell-title",
        headerCssClass: "header-column-first",
        sortable: true,
        formatter: homeItemNameFormatter
      },
      {
        id: "type",
        name: "Type",
        field: "type",
        width: 65,
        cssClass: "cell-title",
        headerCssClass: "header-column",
        sortable: true,
        formatter: homeItemTypeFormatter
      },
      {
        id: "status",
        name: "Status",
        field: "status",
        width: 65,
        cssClass: "cell-title",
        headerCssClass: "header-column",
        sortable: true,
        formatter: homeItemStatusFormatter
      },
      {
        id: "modified",
        name: "Last Modified",
        field: "modified",
        width: 100,
        cssClass: "cell-title",
        headerCssClass: "header-column",
        sortable: true,
        formatter: gridFormatters.dateFormatter
      },
      {
        id: "trainerName",
        name: "Trainer Name",
        field: "trainerName",
        width: 150,
        cssClass: "cell-title",
        headerCssClass: "header-column",
        sortable: true,
        formatter: homeTrainerNameFormatter
      }
    ];
    var catalogColumns = _.reject(columns, function (column) {
      return column.id === "status" || column.id === "trainerName"
    });

    $scope.gridInfo = {
      options: {
        editable: false,
        enableCellNavigation: false,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        multiColumnSort: true
      },
      highlightRowsEnabled: true,
      columns: columns,
      data: $scope.items,
      onClick: $scope.selectItem,
      onSort: saveSort
    };

    // filled by our slickGrid directive, yes really
    var gridCommands = $scope.gridCommands = {
      onGridCreated: onGridCreated
    };

    function onGridCreated() {
      var p = $scope.homeState.viewPreferences;
      gridCommands.setSortColumn(p.sortField, p.sortDirection == 'asc');
      $scope.gridInfo.columns = $scope.homeState.viewPreferences.typeFilter == "catalog" ? gridCommands.setColumns(catalogColumns) : gridCommands.setColumns(columns);
    }

    var gaActions = trackingService.pages.trainerHome.actions;
    var gaPageName = trackingService.pages.trainerHome.name;
    var gaListSortMap = {
      name: gaActions.listSearchSortName,
      type: gaActions.listSearchSortType,
      status: gaActions.listSearchSortStatus,
      modified: gaActions.listSearchSortModified,
      trainerName: gaActions.listSearchSortTrainerName
    };

    function saveSort(asc, field) {
      $scope.homeState.viewPreferences.sortField = field;
      $scope.homeState.viewPreferences.sortDirection = asc ? 'asc' : 'desc';

      trackingService.trackEvent(gaPageName, gaListSortMap[field]);

      $scope.storePreferences();
    }

    var typeStrings = {
      series: 'Series',
      online: 'Course',
      live: 'Live Training',
      catalog: 'Catalog Page'
    };

    function homeItemTypeFormatter(row, cell, value, columnDef, item) {
      return typeStrings[item.type];
    }

    var statuses = {
      draft: {name: 'Draft', icon: 'icon-circle'},
      active: {name: 'Active', icon: 'icon-circle'},
      archive: {name: 'Archived', icon: 'icon-circle'}
    };

    function homeItemStatusFormatter(row, cell, value, columnDef, item) {
      var status = statuses[item.status];
      if (item.status == 'series' || !status)
        return '<p style="padding-left: 15px;">&#151;</p>';

      return '<span class="home-item-status-' + item.status + '"><i class="' + status.icon + '"></i>&nbsp;&nbsp;' + status.name + '</span>';
    }

    $scope.homeListItemOverId = null;
    function homeItemNameFormatter(row, cell, value, columnDef, item) {
      var name = escapeHtml(item.name);

      return '<div class="home-item-name" style="width: auto; float: left">' + name + '</div>'
        + '<div><a class="home-list-row-open" id="openCourseLink-'
        + item.id + '" href="' + $scope.getItemUrl(item) + '"><i class="icon-external-link"></i></a></div>'
    }

    function homeTrainerNameFormatter(row, cell, value, columnDef, item) {
      var trainerName = escapeHtml(item.trainerName);

      return trainerName ? trainerName : '<p style="padding-left: 15px;">&#151;</p>';
    }

    $scope.$watch('homeState.selectedItem', function (item) {
      if (!gridCommands.highlightGridRow) return;
      gridCommands.highlightGridRow(item && item.id);
      gridCommands.scrollItemIntoView(item && item.id);
    });

    $scope.$watch('homeState.search.typeFilter', function (value) {
      if (!gridCommands.setColumns) return;
      $scope.gridInfo.columns = value == "catalog" ? gridCommands.setColumns(catalogColumns) : gridCommands.setColumns(columns);
    });

    function escapeHtml(unsafe) {
      if (!unsafe) return unsafe;

      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }
  }

})();
